import React from 'react';
import { Alert, AlertIcon, CloseButton, Text } from '@chakra-ui/core';

interface UploadErrorAlertProps {
  message: string;
  onDismiss: () => void;
  ariaLabel: string;
  testId: string;
}

export const UploadErrorAlert: React.FC<UploadErrorAlertProps> = React.memo(({ message, onDismiss, ariaLabel, testId }) => (
  <Alert status="error" mt={3} mb={1} borderRadius="md" data-testid={testId}>
    <AlertIcon />
    <Text fontSize="sm" flex="1">
      {message}
    </Text>
    <CloseButton size="sm" onClick={onDismiss} aria-label={ariaLabel} />
  </Alert>
));
UploadErrorAlert.displayName = 'UploadErrorAlert';
